import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../../../core/modules/common/components/Modal';
import Button from '../../../../core/modules/common/components/Button';
import { pushHistory } from '../../../../core/modules/common/tools/HistoryTools';
import ReportDefinitions from '../../../common/config/ReportDefinitions';
import SelectionCriteriaDto from '../models/SelectionCriteriaDto';
import {
  reportClearData,
  reportLoadData,
  reportLoadDataCanceled,
  cancelReportRequestActionCreator,
  switchToAsyncReportRequestActionCreator,
  switchToAsyncEnabledRequestActionCreator,
  cancelReportEnabledRequestActionCreator,
} from '../redux/actions/ReportsActions';
import { getSelectionCriteria } from '../../../wizard/common/redux/selectors/SelectionCriteriaWizardSelectors';
import { getCreatedReqParams } from "../../../user/redux/selectors/UserReportSelectors";
import { getEnabledAsyncSwitch, getEnabledCancelReport } from '../redux/selectors/ReportsSelectors';
import themeStyles from "../../../../materialUiTheme";

class OnScreenModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minutes: 0,
      seconds: 0,
      hoverText: '',
      switchButtonEnabled: false,
      // eslint-disable-next-line react/no-unused-state
      cancelEnabled: false,
    };
    this.timer = null;
    this.timerCancel = null;
  }

  componentDidMount() {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.innerHTML =
      'var seconds = 0; var minutes = 0;' +
      'var timerSpan = document.getElementById(\'timerSpan\');' +
      'var timer = setInterval(() => {' +
      ' timerSpan.innerHTML = (\'0\' + minutes).slice(-2) + \':\' + (\'0\' + seconds).slice(-2);' +
      ' minutes = seconds == 59 ? minutes + 1:minutes;' +
      ' seconds = seconds < 59 ? seconds + 1:0;' +
      '}, 1000);';
    document.body.appendChild(s);
    const { requestId } = this.props.selectionCriteria;
    if (this.props.enabledCancelReport === false) {
      this.timerCancel = setInterval(() => {
        if (this.props.enabledCancelReport === false) {
          this.props.cancelReportEnabledRequestActionCreator(requestId);
        }
      }, 11000);
    }
    if (this.state.switchButtonEnabled === false) {
      this.timer = setInterval(() => {
        this.setState({
          switchButtonEnabled: this.props.enabledAsyncSwitch === true,
        });
        if (this.state.switchButtonEnabled === false) {
          this.props.switchToAsyncEnabledRequestActionCreator(requestId);
        }
      }, 17000);
    }
  }

  /* componentDidUpdate(prevProps) {
    const { requestId } = this.props.selectionCriteria;
    console.log(prevProps.enabledCancelReport, this.props.enabledCancelReport, this.state.number)
    if (this.props.enabledCancelReport !== undefined && this.props.enabledCancelReport === false) {
      this.timer = setTimeout(() => {
        this.props.cancelReportEnabledRequestActionCreator(requestId);
      }, 3000);
    } else {
      clearTimeout(this.timer);
      console.log("cleared");
    }
  } */

  componentWillUnmount() {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.innerHTML = 'clearInterval(timer);';
    document.body.appendChild(s);
    clearInterval(this.timer);
    clearInterval(this.timerCancel);
  }

  hoverChangeCancel = () => {
    this.setState({
      hoverText: 'Click Cancel to cancel the report request.',
    });
  };

  hoverChangeEmail = () => {
    this.setState({
      hoverText: 'Click E-mail to receive a link by e-mail to download the report.',
    });
  };

  leaveHover = () => {
    this.setState({
      hoverText: '',
    });
  };

  cancel = (reportId, mainReportId) => {
    const id = mainReportId || reportId;
    // localizedPushHistory(`/report-wizard/${id}/period`);
    pushHistory(`/report-wizard/${id}/period`);
    const { requestId } = this.props.selectionCriteria;
    this.props.cancelReportRequestActionCreator(requestId);
    this.props.reportLoadDataCanceled();
  };

  createEmailReportHandler = () => {
    const reportName = this.props.reportId;
    const { mainReportId } = this.props.reporting[reportName];
    const reportId = mainReportId || reportName;
    const report = ReportDefinitions[reportId];
    const requestParams = this.props.createdReqParams;

    // eslint-disable-next-line max-len
    const selectionCriteria = new SelectionCriteriaDto(this.props.selectionCriteria, report.selectionCriteria.items);
    selectionCriteria.requestMode = 'ASYNC';
    const { requestId } = this.props.selectionCriteria;
    selectionCriteria.requestId = requestId;
    const newRequestParams = { ...requestParams };
    newRequestParams.requestMode = 'ASYNC';
    newRequestParams.requestId = requestId;
    this.props.switchToAsyncReportRequestActionCreator(requestId);
    this.props.reportLoadDataCanceled();
    // localizedPushHistory(`/report-wizard/${reportId}/period`);
    pushHistory(`/report-wizard/${reportId}/period`);
    // if (Object.keys(requestParams).length === 0) {
    //   this.props.reportLoadData(report, null, selectionCriteria);
    // } else {
    //   this.props.reportLoadData(report, null, newRequestParams);
    // }
    // this.props.reportLoadData(report, null, selectionCriteria);
  };

  render() {
    const {
      closeChart,
      reportId,
      mainReportId,
      enabledAsyncSwitch,
      enabledCancelReport,
    } = this.props;
    const { minutes, seconds, hoverText } = this.state;
    return (
      <div className="chart-modal">
        <Modal
          closeOnOutsideClick
          onClose={closeChart}
        >
          <div className="chart-modal__wrapper" style={{ position: 'relative', height: '250px' }}>
            <span id="loadingSpan" style={{ marginTop: '10px' }}>
              (Please note: For large data sets, the timer may stop or the browser may appear unresponsive before the report appears on screen).
            </span>
            <br /><br />
            <span>Working...</span>
            <div>
              <div>
                <h3><span id="timerSpan">{minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}</span></h3>
              </div>
              <div>
                <span>
                  Click Cancel to cancel the report request.
                </span>
              </div>
              <div>
                <span>
                  Click E-mail to receive a link by e-mail to download the report.
                </span>
              </div>
              <div className="onscreen-modal-button-container">
                {/* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */}
                <div onMouseOver={this.hoverChangeCancel} onMouseLeave={this.leaveHover}>
                  <Button
                    className="cancel-button"
                    text="app.button.cancel"
                    disabled={!enabledCancelReport}
                    onClick={() => this.cancel(reportId, mainReportId)}
                    style={enabledCancelReport ? themeStyles.blueButton : {}}
                  />
                </div>
                {/* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */}
                <div onMouseOver={this.hoverChangeEmail} onMouseLeave={this.leaveHover}>
                  <Button
                    className="email-button"
                    text="app.button.email"
                    disabled={!enabledAsyncSwitch}
                    onClick={() => this.createEmailReportHandler()}
                    style={enabledAsyncSwitch ? themeStyles.blueButton : {}}
                  />
                </div>
              </div>
              <div>{hoverText}</div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectionCriteria: getSelectionCriteria(state),
    createdReqParams: getCreatedReqParams(state),
    enabledAsyncSwitch: getEnabledAsyncSwitch(state),
    enabledCancelReport: getEnabledCancelReport(state),
  };
}

const mapDispatchToProps = dispatch => bindActionCreators({
  reportClearData,
  reportLoadData,
  reportLoadDataCanceled,
  cancelReportRequestActionCreator,
  switchToAsyncReportRequestActionCreator,
  switchToAsyncEnabledRequestActionCreator,
  cancelReportEnabledRequestActionCreator,
}, dispatch);


OnScreenModal.propTypes = {
  closeChart: PropTypes.func.isRequired,
  reportId: PropTypes.string,
  mainReportId: PropTypes.string,
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  // eslint-disable-next-line react/no-unused-prop-types
  reportLoadData: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  reportClearData: PropTypes.func,
  reportLoadDataCanceled: PropTypes.func,
  cancelReportRequestActionCreator: PropTypes.func,
  switchToAsyncReportRequestActionCreator: PropTypes.func,
  switchToAsyncEnabledRequestActionCreator: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  cancelReportEnabledRequestActionCreator: PropTypes.func,
  reporting: PropTypes.objectOf(PropTypes.shape),
  createdReqParams: PropTypes.objectOf(PropTypes.shape),
  enabledAsyncSwitch: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  enabledCancelReport: PropTypes.bool,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OnScreenModal);

